export const ATTIK_LOAD_ID_HEADER = 'x-attik-load-id';
export const ATTIK_CACHE_HEADER = 'x-attik-cache';

export const COMPANY_SWITCH_TRIGGER_KEY = 'company-switch-trigger';
export const DEFERRED_LOAD_MS = 2500;
export const LOAD_SUMMARY_SETTLE_MS = 600;
export const LOAD_SUMMARY_TIMEOUT_MS = 35_000;

export const DEFAULT_DASHBOARD_PERF_SAMPLE_RATE = 0.1;

export type DashboardLoadTrigger = 'initial' | 'company_switch' | 'reload';
